import store from '@/store/index'
import {
  authorityTemplate
} from '@/public/constant/template.js'
export default {
  // 获取权限
  AuthorityFilter(path) {
    let authority = JSON.parse(JSON.stringify(authorityTemplate))

    let menu = JSON.parse(JSON.stringify(store.state.menulist))

    for (let item of menu) {
      for (let subItem of item.children) {
        if (subItem.children) {
          for (let i of subItem.children) {
            if ('/' + i.path === path) {
              authority.see = i.seeType > 0
              authority.seeType = i.seeType
              authority.alEffectCondition = i.alEffectCondition
              authority.edit = i.edit > 0
              authority.special = i.special
              authority.showMoney = i.edit > 0
              authority.autoCode = i.ifAutoNum === '是'
              for (let special of i.special) {
                if (special.name === 'showMoney') {
                  authority.showMoney = true
                }
              }
              return authority
            }
          }
        } else {
          if ('/' + subItem.path === path) {
            authority.see = subItem.seeType > 0
            authority.seeType = subItem.seeType
            authority.alEffectCondition = subItem.alEffectCondition
            authority.edit = subItem.edit > 0
            authority.special = subItem.special
            authority.showMoney = subItem.edit > 0
            for (let special of subItem.special) {
              if (special.name === 'showMoney') {
                authority.showMoney = true
              }
            }
            return authority
          }
        }
      }
    }

    return authority
  },
}